import { Reveal } from "./Reveal";
import { HardHat, Truck, Factory, Package, Hotel, Wrench, Wheat, Cog } from "lucide-react";

const INDUSTRIES = [
  [HardHat, "Construction"],
  [Truck, "Transport & Logistics"],
  [Factory, "Manufacturing"],
  [Package, "Warehousing"],
  [Hotel, "Hospitality"],
  [Wrench, "Skilled Trades"],
  [Wheat, "Agriculture / Seasonal"],
  [Cog, "Engineering & Technical"],
];

export const Industries = () => (
  <section
    id="industries"
    data-testid="industries-section"
    className="py-24 md:py-32 px-6 md:px-12 bg-[#f5f5f4] border-y border-[#e4e4e7]"
  >
    <div className="max-w-[1600px] mx-auto">
      <Reveal>
        <p className="font-body text-sm tracking-[0.25em] uppercase text-[#ff3b30] mb-6">
          Industries we serve
        </p>
        <h2 className="font-head uppercase tracking-tighter leading-[0.9] text-5xl md:text-7xl xl:text-8xl mb-16 md:mb-20">
          Sectors we
          <br />
          staff.
        </h2>
      </Reveal>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {INDUSTRIES.map(([Icon, name], i) => (
          <Reveal key={name} delay={(i % 4) * 0.06}>
            <div
              data-testid={`industry-${i}`}
              className="group bg-white border border-[#e4e4e7] hover:border-[#ff3b30] p-8 h-full flex flex-col items-start justify-between aspect-square transition-colors duration-400"
            >
              <Icon size={34} className="text-[#0a0a0a] group-hover:text-[#ff3b30] transition-colors duration-400" strokeWidth={1.4} />
              <h3 className="font-head uppercase tracking-tight text-lg md:text-2xl mt-6">{name}</h3>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
